module.exports = __webpack_public_path__ + "static/teamleader-4f618c2490840543ea8780f16c924569.png";